<template>
	<div class="output">
		<title-bar :title-stack="titleStack"/>

		<section class="section is-main-section">
			<card-component title="" icon="">

				<b-field label="種類" horizontal>
					<b-select v-model="typeId">
						<option v-for="row in types" :key="row.id" :value="row.id">
							{{ row.name }}
						</option>
					</b-select>
				</b-field>

				<b-field label="集計※" horizontal>
					<b-field grouped>
						<b-select v-model="year">
							<option v-for="row in years" :key="row" :value="row">
								{{ row }}
							</option>
						</b-select>

						<div class="mr-20">年</div>

						<b-select v-show="isMonthShow" v-model="month">
							<option v-for="n in 12" :key="n" :value="$utils.zeroPadding(n, 2)">
								{{ n }}
							</option>
						</b-select>

						<div v-show="isMonthShow">月</div>
					</b-field>
				</b-field>

				<b-field label="" horizontal style="margin-top: -10px;">
					<div style="font-size:13px">※集計データは月末に確定します。</div>
				</b-field>

				<b-field label="" horizontal class="mb-20" style="margin-top: -10px;">
					<div style="font-size:13px">※月末を迎えていない、当月の出力をする場合は集計結果が正しく出ない可能性があります。</div>
				</b-field>

				<b-field label="プリセット" horizontal>
					<b-select v-model="presetId">
						<option v-for="(row, index) in presets" :key="row.id" :value="row.id">
							{{ row.name }}
						</option>
					</b-select>
				</b-field>

				<div v-show="isCoinShow">
					<b-field :label="`コイン(${coinMax}種類まで)`" horizontal>
						<b-checkbox class="ml-10" v-model="isCoinAllCheck" @input="onCoinAllCheckChange">全選択/解除</b-checkbox>
					</b-field>

					<b-field label="" horizontal style="margin-top: -20px;">
						<div class="team-select-wrap">
							<div v-for="row in coins" :key="row.id">
								<div class="mb-10">
									<b-checkbox v-model="checkedCoins"
										:native-value="row.id" @input="onCoinCheckChange">
										{{ row.name }}
									</b-checkbox>
								</div>
							</div>
						</div>
					</b-field>

					<b-field label="" horizontal>
						<div>{{ checkedCoins.length }} 種類選択済み（{{ coins.length }}種類中）</div>
					</b-field>

					<b-field label="" horizontal>
						<div v-show="isCoinOver" style="color:red">選択可能なコイン数を超えています</div>
					</b-field>
				</div>

				<b-field class="mt-30" horizontal>
					<div>
						<b-button type="is-info" class="" :loading="isLoading" @click="onOutputClick" :disabled="!isValid">出力</b-button>
					</div>
				</b-field>
			</card-component>
		</section>
	</div>
</template>

<style lang="scss" scoped>
.team-select-wrap {
	height: 330px;
	overflow: scroll;
	border: 1px solid #eee;
	padding: 10px;
}
</style>

<script>
import TitleBar from '@/components/TitleBar'
import CardComponent from '@/components/CardComponent'
import TableEmpty from '@/components/TableEmpty'
import PageInfo from '@/components/PageInfo'
import SearchBar from '@/components/SearchBar'
import DatePicker from '@/components/DatePicker'
import moment from 'moment'

export default {
	name: 'ouput',
	components: {
		TitleBar,
		CardComponent,
		TableEmpty,
		PageInfo,
		SearchBar,
		DatePicker,
	},
	data() {
		return {
			isLoading: false,
			typeId: 0,
			year: null,
			month: null,
			presetId: '',
			checkedCoins: [],
			coins: [],
			presets: [],
			years: [],
			types: [],
			coinMax: 16,
			isCoinAllCheck: true,
		}
	},
	computed: {
		titleStack () {
			return [
				'帳票出力'
			]
		},
		isCoinOver: function() {
			return this.checkedCoins.length > this.coinMax;
		},
		isValid: function() {
			if (!this.isCoinShow) return true;
			return this.checkedCoins.length <= this.coinMax && this.checkedCoins.length > 0;
		},
		isCoinShow: function() {
			return this.typeId === 0 || this.typeId === 2;
		},
		isMonthShow: function() {
			return this.typeId === 0 || this.typeId === 3;
		},
	},
	created() {
		this.year = moment().format('YYYY');
		for (let i = 2020; i <= parseInt(this.year); i++) {
			this.years.push(i);
		}

		this.month = moment().format('MM');

		this.types = [
			{ id: 0, name: 'フィードバック' },
			{ id: 1, name: '推移表 獲得コイン' },
			{ id: 4, name: '推移表 獲得コイン平均' },
			{ id: 2, name: '推移表 コインの種類' },
			{ id: 3, name: '獲得シェア表' },
		];
	},
	mounted() {
		this.init();
	},
	methods: {
		onCoinAllCheckChange: function() {
			if (this.isCoinAllCheck) {
				this.checkAllCoins();
			} else {
				this.checkedCoins = [];
			}
		},
		onCoinCheckChange: function() {
			this.isCoinAllCheck = this.checkedCoins.length === this.coins.length;
		},
		checkAllCoins: function() {
			this.checkedCoins = [];
			for (let i in this.coins) {
				this.checkedCoins.push(this.coins[i].id);
				//if (i == 4) break;
			}
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			let loader = this.$buefy.loading.open();
			let ep = 'outputs';
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.coins = res.data.coins;
				this.presets = res.data.presets;
				this.presetId = this.presets[0].id;

				this.checkAllCoins();

				// デバッグ ///////////////////////
				//this.checkedCoins.push('49213926-312a-45bb-89a4-ca6aae171c80');
				//this.month = '05';
				//this.typeId = 0;
				//this.presetId = '74c69385-a5dc-4864-98f0-5047f2ed4cd2';
				//this.onOutputClick();
				//////////////////////////////////
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close()
			}
		},
		onOutputClick: async function() {
			this.isLoading = true;

			let ep = 'outputs/download';
			this.$utils.log(ep);

			let data = {
				"type": this.typeId,
				"year": this.year,
				"month": this.month,
				"preset_id": this.presetId,
				"coins": this.checkedCoins.length > 0 ? this.checkedCoins : '',
			};
			this.$utils.log(data);

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);

				let link = document.createElement('a')
				link.href = window.URL.createObjectURL(this.$utils.toBlob(res.data.body, res.data.mime_type))
				link.download = res.data.file_name;
				link.click()
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
	},
}
</script>
